import { getPromoMessaging } from "../../utils/product/getPromoMessaging";
import styles from "./PromotionalMessages.module.scss";
import { PRODUCT_SPECIAL_OFFERS_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductSpecialOffersAccordion/ProductSpecialOffersAccordionUI";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import { PromotionalMessageItem } from "./PromotionalMessageItem";

type Props = {
  /**
   * An array of Message objects.
   */
  promotionalMessages: (PromotionalMessage | NonPromotionalMessage)[];

  /**
   * Flag to show Promotional messages on page and not drawer.
   */
  hidePromoDrawer: boolean;
  isOldPromoAccordion: boolean;
  isNewPromoListItem: boolean;
  isNewPromoDrawer: boolean;

  /**
   * String to show which Promotional message timer variant (A/B/C).
   */
  countdownTimerVariant: string;

  /**
   * Flag to determine if product in countdown test is available to order.
   */
  countdownTimerAvailabileToOrder: boolean;
};

const MAX_PROMO_MESSAGES = 2;

function dispatchAccordionOpenEvent(target: string) {
  const event = new CustomEvent(`jlds:accordion:${target}`, {
    detail: { action: "open" },
  });
  document.body.dispatchEvent(event);
}

export const PromotionalMessagesUI = ({
  promotionalMessages,
  hidePromoDrawer = false,
  isOldPromoAccordion = false,
  isNewPromoListItem = false,
  isNewPromoDrawer = false,
  countdownTimerVariant,
  countdownTimerAvailabileToOrder,
}: Props) => {
  const pageMessages =
    !isNewPromoDrawer && (isOldPromoAccordion || hidePromoDrawer)
      ? promotionalMessages
      : getPromoMessaging(
          promotionalMessages,
          isNewPromoListItem || isNewPromoDrawer,
        ).pageMessages;

  if (pageMessages.length === 0) return null;

  const scrollToTarget = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const hrefTarget = e.currentTarget.getAttribute("data-href") || "";
    dispatchAccordionOpenEvent(PRODUCT_SPECIAL_OFFERS_ACCORDION_INSTANCE_NAME);
    document
      .querySelector(hrefTarget)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="product:promotional-messages"
      className={styles.promotionalMessagesWrapper}
    >
      {pageMessages
        .slice(0, MAX_PROMO_MESSAGES)
        .map((message: PromotionalMessage | NonPromotionalMessage, idx) => {
          if (
            message.description &&
            !isNewPromoDrawer &&
            (isOldPromoAccordion || hidePromoDrawer)
          ) {
            return (
              <button
                className={styles.messageLink}
                data-href="#accordion-special-offers"
                onClick={scrollToTarget}
                key={idx}
              >
                <p className={styles.message}>{message.title}</p>
              </button>
            );
          }
          return (
            <PromotionalMessageItem
              message={message}
              key={idx}
              countdownTimerVariant={countdownTimerVariant}
              countdownTimerAvailabileToOrder={countdownTimerAvailabileToOrder}
            />
          );
        })}
    </div>
  );
};
